module.exports = __webpack_public_path__ + "img/icon_sec2_01.8a6fef62.png";